module.exports = __webpack_public_path__ + "141d4a85/img/print-icon.d8dbbca5.svg";